module.exports = __webpack_public_path__ + "assets/img/29_300.89925532.jpg";